'use client';
import Link from 'next/link';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ErrorPage = () => {
    return (
        <div className='flex flex-col items-center justify-center grow h-[95%]'>
            <div className="mb-10">
                <img
                    src={'/assets/media/illustrations/20.svg'}
                    className="dark:hidden max-h-[160px]"
                    alt="image"
                />
                <img
                    src={'.assets/media/illustrations/20-dark.svg'}
                    className="light:hidden max-h-[160px]"
                    alt="image"
                />
            </div>

            <span className="badge badge-primary badge-outline mb-3"><FormattedMessage id="ERROR_500_TITLE" /></span>

            <h3 className="text-2.5xl font-semibold text-gray-900 text-center mb-2">
                <FormattedMessage id="ERROR_500_SUBTITLE" />
            </h3>

            <div className="text-md text-center text-gray-700 mb-10">
                <FormattedMessage
                    id="ERROR_500_MESSAGE"
                    defaultMessage="Server error occurred. Please try again later or {contactLink} for assistance."
                    values={{
                        contactLink: (
                            <a
                                href="https://admin.t3element.com"
                                className="text-primary font-medium hover:text-primary-active"
                            >
                                <FormattedMessage id="ERROR_500_CONTACTUS" defaultMessage="Contact Us" />
                            </a>
                        ),
                    }}
                />
            </div>

            <Link href="/" className="btn btn-primary flex justify-center">
                <FormattedMessage id="ERROR_500_BACK_HOME" />
            </Link>
        </div>
    );
};

export default ErrorPage;